// extracted by mini-css-extract-plugin
module.exports = {"error":"ErrorBoundary_error__Vx28z"};